import React, {useEffect, useState} from 'react';
import {
  Document,
  Page,
  View,
  Text,
  Link,
  Font,
  StyleSheet,
  Image
} from '@react-pdf/renderer';
import ier_logo from '../../assets/images/icons/ier-logo2.png'
import moment from 'moment';
import pdfReport from './pdfReport';


const styles = StyleSheet.create({
  title: {
    margin: 20,
    fontSize: 25,
    textAlign: 'center',
    backgroundColor: '#e4e4e4',
    textTransform: 'uppercase',
    fontFamily: 'Oswald',
  },
  title_container:{
    display: 'flex',
    flexDirection: 'row',
    padding: 20,
    backgroundColor: '#e7eaf3',
  },
  title_text:{
    fontSize: 10,
  },
  text_container:{
    flex: 1,
    marginLeft: 20
  },
  logo:{
    width: "100%"
  },
  header_title:{
    fontWeight: 'bold',
    fontSize: 20,
    color: '#0C8444',
    textTransform: 'uppercase'
  },
  body: {
    flexGrow: 1,
    padding: 20
  },
  row: {
    borderBottomWidth: 1,
    borderBottomColor: '#e4e4e4',
    paddingVertical: 15
  },
  content_title:{
    fontSize: 9,
    marginBottom: 5
  },
  content_sub_title:{
      fontSize: 14,
      fontWeight: 'bold'
  },
  content_container:{
    flexDirection: 'column', 
    justifyContent: 'space-between', 
    paddingTop: 10,
    width: '50%'
  },
  content_sub_container:{
    padding: '10px 0px'
  },
  seperator:{
      border: '2px dashed #D6D6D6'
  }
});

Font.register({
  family: 'Oswald',
  src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf',
});


const  PdfReport =  (props) => {

    const [details, setDetails] = useState('')

    useEffect(()=>{ 
        setDetails(props.data)
    },[props.data])

return(
  <Document>
    <Page size="A4" style={{paddingBottom: 10}}>
        <View style={styles.title_container}>
            <Image src={ier_logo} style={styles.logo}/>
        </View>
      <View style={styles.body}>
        <View style={styles.row}>
          <Text style={styles.header_title}>Personal details</Text>
          <View style={[styles.content_container, {height: 100}]}>
                <Image src={`data:image/${details.portraitPhotoFile?.type};base64,${details.portraitPhotoFile?.fileText}`} style={{width: '20%', height: '100%'}}/>
            </View>
          <View style={{flexDirection: 'row'}}>
                <View style={styles.content_container}>
                        <View style={styles.content_sub_container}>
                            <Text style={styles.content_title}>Title</Text>
                            <Text style={styles.content_sub_title}>{details?.title || '-'}</Text>
                        </View>
                        <View style={styles.content_sub_container}>
                            <Text style={styles.content_title}>Gender</Text>
                            <Text style={styles.content_sub_title}>{details.gender}</Text>
                        </View>
                        
                </View>
                <View style={styles.content_container}>
                      <View style={styles.content_sub_container}>
                            <Text style={styles.content_title}>First Name</Text>
                            <Text style={styles.content_sub_title}>{details?.lastname || '-'}</Text>
                        </View>
                        <View style={styles.content_sub_container}>
                            <Text style={styles.content_title}>Date of Birth</Text>
                            <Text style={styles.content_sub_title}>{details?.dateOfBirth && moment(details?.dateOfBirth)?.format('MMMM Do YYYY') || '-'}</Text>
                        </View>
                </View>
                <View style={styles.content_container}>
                        <View style={styles.content_sub_container}>
                            <Text style={styles.content_title}>Last Name</Text>
                            <Text style={styles.content_sub_title}>{details?.firstname || '-'}</Text>
                        </View>
                        <View style={styles.content_sub_container}>
                            <Text style={styles.content_title}>Discipline</Text>
                            <Text style={styles.content_sub_title}>{details?.discipline?.name || '-'}</Text>
                        </View>
                </View>
                <View style={styles.content_container}>
                        <View style={styles.content_sub_container}>
                            <Text style={styles.content_title}>Education Level</Text>
                            <Text style={styles.content_sub_title}>{details?.awardType?.name || '-'}</Text>
                        </View>
                </View>
          </View>
        </View>

        <View style={styles.row}>
          <Text style={styles.header_title}>Contact details</Text>
          <View style={{flexDirection: 'row'}}>
                <View style={styles.content_container}>
                        <View style={styles.content_sub_container}>
                            <Text style={styles.content_title}>Phone number</Text>
                            <Text style={styles.content_sub_title}>{details?.contactTelephoneNumber || ''}</Text>
                        </View>
                        <View style={styles.content_sub_container}>
                            <Text style={styles.content_title}>Email address</Text>
                            <Text style={styles.content_sub_title}>{details?.contactEmail || '-'}</Text>
                        </View>
                </View>
                <View style={styles.content_container}>
                        <View style={styles.content_sub_container}>
                            <Text style={styles.content_title}>Secondary Phone number</Text>
                            <Text style={styles.content_sub_title}>{details?.secondaryContactTelephoneNumber || '-'}</Text>
                        </View>
                        <View style={styles.content_sub_container}>
                            <Text style={styles.content_title}>Main Email address</Text>
                            <Text style={styles.content_sub_title}>{details?.secondaryContactEmail || '-'}</Text>
                        </View>
                </View>
                <View style={styles.content_container}>
                        <View style={styles.content_sub_container}>
                            <Text style={styles.content_title}>Residence Address</Text>
                                {details.residenceType === 'Local' ? 
                                <Text style={styles.content_sub_title}>
                                    {details.provinceId?.name}, 
                                    {details.districtId?.name}, 
                                    {details.sectorId?.name}, 
                                    {details.cellId?.name}, 
                                    {details.villageId?.name}, 
                                    {details.streetOrHouseNumber}
                                </Text>: 
                                <Text style={styles.content_sub_title}>
                                    {details.countryOfResidence?.name},
                                    {details.residenceAddress}
                                </Text>
                                }
                        </View>
                </View>
          </View>
        </View>

        <View style={styles.row}>
          <Text style={styles.header_title}>Educational details</Text>
          <>
            { details.educationDetails?.length> 0  &&  details.educationDetails?.map(value=>{
                return(
                    <>
                    <View style={{flexDirection: 'row'}}>
                        <View style={styles.content_container}>
                            <View style={styles.content_sub_container}>
                                <Text style={styles.content_title}>Institution Name</Text>
                                <Text style={styles.content_sub_title}>{value?.institutionName}</Text>
                            </View>
                            <View style={styles.content_sub_container}>
                                <Text style={styles.content_title}>Award Type</Text>
                                <Text style={styles.content_sub_title}>{value?.awardTypeId?.name}</Text>
                            </View>
                        </View>
                        <View style={styles.content_container}>
                            <View style={styles.content_sub_container}>
                                <Text style={styles.content_title}>Phone</Text>
                                <Text style={styles.content_sub_title}>{value?.telephoneNumber}</Text>
                            </View>
                            <View style={styles.content_sub_container}>
                                <Text style={styles.content_title}>Year of Award</Text>
                                <Text style={styles.content_sub_title}>{value?.yearOfAward}</Text>
                            </View>
                        </View>
                        <View style={styles.content_container}>
                                <View style={styles.content_sub_container}>
                                    <Text style={styles.content_title}>Certified Award Attached</Text>
                                    <Text style={styles.content_sub_title}>{value?.awardDocumentFile?.name}</Text>
                                </View>
                        </View>
                    </View>
                    <View style={styles.seperator}></View>
                    </>
                )
            })  
            }
          </>
        </View>



        <View style={styles.row}>
          <Text style={styles.header_title}>CERTIFICATION DETAILS</Text>
        { details.professionalCertificates?.length> 0 &&  details.professionalCertificates.map(value=>{
            return(
                <>
                <View style={{flexDirection: 'row'}}>
                    <View style={styles.content_container}>
                            <View style={styles.content_sub_container}>
                                <Text style={styles.content_title}>Certificate Name</Text>
                                <Text style={styles.content_sub_title}>{value.name}</Text>
                            </View>
                    </View>
                    <View style={styles.content_container}>
                            <View style={styles.content_sub_container}>
                                <Text style={styles.content_title}>Provider</Text>
                                <Text style={styles.content_sub_title}>{value.provider}</Text>
                            </View>
                    </View>
                    <View style={styles.content_container}>
                            <View style={styles.content_sub_container}>
                                <Text style={styles.content_title}>Location</Text>
                                <Text style={styles.content_sub_title}>{value.location}</Text>
                            </View>
                    </View>
                </View>
                <View style={{flexDirection: 'row'}}>
                    <View style={styles.content_container}>
                            <View style={styles.content_sub_container}>
                                <Text style={styles.content_title}>Start Date</Text>
                                <Text style={styles.content_sub_title}>{moment(value.startDate).format('MMM Do YYYY')}</Text>
                            </View>
                    </View>
                    <View style={styles.content_container}>
                            <View style={styles.content_sub_container}>
                                <Text style={styles.content_title}>End Date</Text>
                                <Text style={styles.content_sub_title}>{moment(value.endDate).format('MMM Do YYYY')}</Text>
                            </View>
                    </View>
                    <View style={styles.content_container}>
                            <View style={styles.content_sub_container}>
                                <Text style={styles.content_title}>Certified Award Attached</Text>
                                <Text style={styles.content_sub_title}>{value.certificateDocumentFile?.name}</Text>
                            </View>
                    </View>
                </View>
                <View style={styles.seperator}></View>
                </>
            )
        })
         }
        </View>


      {details.professionalReferences?.length > 0 &&  <View style={styles.row}>
          <Text style={styles.header_title}>Professional Reference</Text>
          <>
            {details.professionalReferences?.map(value=>{
                return(
                    <>
                    <View style={{flexDirection: 'row'}}>
                        <View style={styles.content_container}>
                            <View style={styles.content_sub_container}>
                                <Text style={styles.content_title}>Full Names</Text>
                                <Text style={styles.content_sub_title}>{value?.name}</Text>
                            </View>
                        </View>
                        <View style={styles.content_container}>
                            <View style={styles.content_sub_container}>
                                <Text style={styles.content_title}>Member Number</Text>
                                <Text style={styles.content_sub_title}>{value?.ierMemberNumber}</Text>
                            </View>
                        </View>
                        <View style={styles.content_container}>
                              <View style={styles.content_sub_container}>
                                  <Text style={styles.content_title}>Member Grade</Text>
                                  <Text style={styles.content_sub_title}>{value?.memberGradeId}</Text>
                              </View>
                        </View>
                    </View>
                    <View style={styles.seperator}></View>
                    </>
                )
            })  
            }
          </>
        </View>}


      {details.academicReferences?.length > 0 &&  <View style={styles.row}>
          <Text style={styles.header_title}>Academic Reference</Text>
          <>
            {details.academicReferences?.map(value=>{
                return(
                    <>
                    <View style={{flexDirection: 'row'}}>
                        <View style={styles.content_container}>
                            <View style={styles.content_sub_container}>
                                <Text style={styles.content_title}>Full Names</Text>
                                <Text style={styles.content_sub_title}>{value?.name}</Text>
                            </View>
                        </View>
                        <View style={styles.content_container}>
                            <View style={styles.content_sub_container}>
                                <Text style={styles.content_title}>Phone Number</Text>
                                <Text style={styles.content_sub_title}>{value?.telephoneNumber}</Text>
                            </View>
                        </View>
                        <View style={styles.content_container}>
                              <View style={styles.content_sub_container}>
                                  <Text style={styles.content_title}>Email Address</Text>
                                  <Text style={styles.content_sub_title}>{value?.email}</Text>
                              </View>
                        </View>
                    </View>
                    <View style={styles.seperator}></View>
                    </>
                )
            })  
            }
          </>
        </View>}

      </View>
    </Page>
  </Document>
)
};

export default PdfReport